var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningOrange = function SvgWarningOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#F80",
    fillOpacity: 0.14,
    rx: 28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F80",
    d: "M28 42.167c-7.824 0-14.166-6.343-14.166-14.167S20.176 13.833 28 13.833 42.167 20.176 42.167 28 35.824 42.167 28 42.167m-1.416-15.584v8.5h2.833v-8.5zm0-5.666v2.833h2.833v-2.833z"
  })));
};
export default SvgWarningOrange;